export class Gtm {
  gtm: ReturnType<typeof useScriptGoogleTagManager>;

  constructor() {
    const { $config } = useNuxtApp();

    this.gtm = useScriptGoogleTagManager({
      id: $config.public.googleTagManagerId,
    });
  }

  page(pageName: string, properties: Record<string, any> = {}) {
    this.gtm.proxy.dataLayer.push({
      event: 'page_view',
      page_name: pageName,
      page_title: document.title,
      page_location: location.href,
      ...properties,
    });
  }

  track(eventName: string, properties: Record<string, any> = {}) {
    this.gtm.proxy.dataLayer.push({
      event: eventName,
      ...properties,
    });
  }
}
